<template>
    <div class="pack-go-nav">
        <BNavbar class="d-none d-lg-flex">
            <BNavbarBrand href="#" style="cursor: default;">
                <img src="~@/assets/pack_go/sendcloud-logo.svg"/>
            </BNavbarBrand>
            <div class="collapse navbar-collapse" id="navbarNav" style="margin-left: 50px">
                <BNavbarNav class="d-none d-lg-flex">
                    <li class="nav-item">
                        <a class="nav-item-link" href="#">Shipping</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-item-link" href="#">Pack & Go</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-item-link" href="#">Returns</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-item-link" href="#">Dynamic Checkout</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-item-link" href="#">Pickups</a>
                    </li>
                </BNavbarNav>
                <BNavbarNav class="icons-item">
                    <li class="nav-item">
                        <a class="nav-icon-link" href="#">
                            <img src="~@/assets/pack_go/nav-icon-1.svg"/>
                        </a>
                        <a class="nav-icon-link" href="#">
                            <img src="~@/assets/pack_go/nav-icon-2.svg"/>
                        </a>
                        <a class="nav-icon-link" href="#">
                            <img src="~@/assets/pack_go/nav-icon-3.svg"/>
                        </a>
                        <a class="nav-icon-link" href="#">
                            <img src="~@/assets/pack_go/nav-icon-4.svg"/>
                        </a>
                        <a class="nav-icon-link" href="#">
                            <img src="~@/assets/pack_go/nav-icon-5.svg"/>
                        </a>
                    </li>
                </BNavbarNav>
            </div>
        </BNavbar>
        <BNavbar toggleable class="d-flex d-lg-none">
            <BNavbarBrand href="#">
                <img src="~@/assets/pack_go/sendcloud-logo.svg"/>
            </BNavbarBrand>

            <BNavbarToggle target="navbar-toggle-collapse ml-5">
                <template #default="{ expanded = true }">
                    <font-awesome-icon v-if="expanded" icon="bars" style="color: #112857"/>
                    <font-awesome-icon v-else icon="bars" style="color: #112857"/>
                </template>
            </BNavbarToggle>

            <BCollapse id="navbar-toggle-collapse" is-nav>
                <BNavbarNav class="ml-auto">
                    <BNavItem href="#">
                        <a class="nav-item-link" href="#">Shipping</a>
                    </BNavItem>
                    <BNavItem href="#">
                        <a class="nav-item-link" href="#">Pack & Go</a>
                    </BNavItem>
                    <BNavItem href="#">
                        <a class="nav-item-link" href="#">Returns</a>
                    </BNavItem>
                    <BNavItem href="#">
                        <a class="nav-item-link" href="#">Dynamic Checkout</a>
                    </BNavItem>
                    <BNavItem href="#">
                        <a class="nav-item-link" href="#">Pickups</a>
                    </BNavItem>
                </BNavbarNav>
                <BNavbarNav class="icons-item">
                    <li class="nav-item">
                        <a class="nav-icon-link" style="margin-left: 0px;" href="#">
                            <img src="~@/assets/pack_go/nav-icon-1.svg"/>
                        </a>
                        <a class="nav-icon-link" href="#">
                            <img src="~@/assets/pack_go/nav-icon-2.svg"/>
                        </a>
                        <a class="nav-icon-link" href="#">
                            <img src="~@/assets/pack_go/nav-icon-3.svg"/>
                        </a>
                        <a class="nav-icon-link" href="#">
                            <img src="~@/assets/pack_go/nav-icon-4.svg"/>
                        </a>
                        <a class="nav-icon-link" href="#">
                            <img src="~@/assets/pack_go/nav-icon-5.svg"/>
                        </a>
                    </li>
                </BNavbarNav>
            </BCollapse>
        </BNavbar>
    </div>
</template>

<script>
    import { BCollapse, BIcon, BNavbar, BNavbarBrand, BNavbarNav, BNavbarToggle, BNavItem } from 'bootstrap-vue';

    export default {
        components: {
            BNavbar,
            BNavbarBrand,
            BNavbarNav,
            BNavbarToggle,
            BIcon,
            BCollapse,
            BNavItem
        }
    }
</script>

<style>
    .nav-item-link {
        font-family: 'Source Sans Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        display: flex;
        color: #212121;
        margin-right: 43px;
        cursor: default;
    }

    @media only screen and (max-width: 1199.98px) {
        .nav-icon-link {
            margin-left: 20px;
            cursor: default;
        }

        .nav-item-link:hover, .nav-item-link:hover{
            text-decoration: none;
        }

        .pack-go-nav {
            background-color: #ffffff;
            padding-top: 20px;
            padding-bottom: 20px;
        }
    }

    @media only screen and (min-width: 1200px) {
        .nav-icon-link {
            margin-left: 46px;
            cursor: default;
        }

        .nav-item-link:hover, .nav-item-link:hover{
            text-decoration: none;
        }

        .pack-go-nav {
            background-color: #ffffff;
            padding-left: 60px;
            padding-right: 60px;
            padding-top: 20px;
            padding-bottom: 20px;
        }
    }

    .icons-item {
        margin-left: auto;
    }
</style>